// 선택하기 전 - 초기화
// 선택하는 중 - active
// 이미 선택된 것 (나왔을 때)

import Image from "next/image";
import { TYPO } from "styles/Typo";
interface selectProp {
  state: "init" | "active" | "complete";
  select: string;
  label?: string;
  size: "md" | "lg";
  type: "box" | "line";
  width?: string;
}

const Select = ({ state, select, size, type, label, width }: selectProp) => {
  if (type === "box") {
    return (
      <div
        className={` ${
          width && width
        } flex-col justify-start gap-1.5 inline-flex `}
      >
        {label && (
          <label className={`text-gray70 pl-1 ${TYPO.TYPO7_MD}`}>{label}</label>
        )}
        <div
          className={`${width && width} relative px-3 cursor-pointer ${
            size === "lg" ? "py-3" : "py-2"
          }justify-start items-center inline-flex  rounded-xl border border-gray5   ${
            size === "lg"
              ? `h-[52px] ${TYPO.TYPO5_MD}`
              : `h-[42px] ${TYPO.TYPO6_MD}`
          }  ${
            state === "init"
              ? "text-gray50 bg-gray2"
              : state === "active"
              ? "text-gray90 bg-gray10"
              : "text-gray90 bg-gray2"
          }`}
        >
          <div className="w-full">{select}</div>
          <Image
            className="absolute top-[50%] right-[0.75rem] translate-y-[-50%]"
            alt="arrow"
            src={`/images/icons/arrowBottom${size === "lg" ? "24" : "20"}.svg`}
            height={18}
            width={18}
          />
        </div>
      </div>
    );
  } else if (type === "line") {
    return (
      <div
        className={`${
          width && width
        } flex-col justify-start gap-1.5 inline-flex`}
      >
        {label && (
          <label
            className={`${TYPO.TYPO7_MD} ${
              state === "active" ? "text-blue40" : "text-gray70"
            }`}
          >
            {label}
          </label>
        )}
        <div
          className={`${width} relative cursor-pointer  ${
            size === "lg" ? "py-3" : "py-2"
          }justify-start items-center inline-flex border-b   ${
            size === "lg"
              ? `h-[52px] ${TYPO.TYPO5_MD}`
              : `h-[42px] ${TYPO.TYPO6_MD}`
          }  ${
            state === "init"
              ? "text-gray50  border-b-gray20"
              : state === "active"
              ? "text-gray90  border-b-blue40"
              : "text-gray90  border-b-gray20"
          }`}
        >
          <div className="w-[273px]">{select}</div>
          <Image
            className="absolute top-[50%] right-[0.75rem] translate-y-[-50%]"
            alt="search"
            src={`/images/icons/arrowBottom${size === "lg" ? "24" : "20"}.svg`}
            height={18}
            width={18}
          />
        </div>
      </div>
    );
  } else return <></>;
};
export default Select;
